let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eW8DF")).then(() => parcelRequire('cqP15'));